// Location config for SEO landing pages
// Each entry powers a /dietitian-in-<slug>-<city> page

export const locations = {
  kharadi: {
    slug: 'dietitian-in-kharadi-pune',
    area: 'Kharadi',
    city: 'Pune',
    tagline: 'Serving Kharadi, Viman Nagar, Wagholi & more',
    heroTitle: 'Best Dietitian in Kharadi, Pune',
    heroSubtitle:
      'Personalised diet plans for weight loss, PCOS, diabetes and pregnancy — crafted by Nutritionist Prachi at NutrifyMe. Face-to-face at our Kharadi clinic near Panchshil Towers, or online for Viman Nagar, Wagholi, Hadapsar and beyond.',
    metaTitle: 'Best Dietitian in Kharadi, Pune — Nutritionist Prachi',
    metaDescription:
      'Top-rated dietitian in Kharadi, Pune. Personalised diet plans for weight loss, PCOS, diabetes and pregnancy — serving Kharadi, Viman Nagar, Wagholi, Hadapsar and Magarpatta. Book a free 15-min call.',
    keywords: [
      'dietitian in kharadi',
      'nutritionist kharadi pune',
      'best dietitian pune',
      'dietitian viman nagar',
      'dietitian wagholi',
      'pcos dietitian kharadi',
      'weight loss dietitian pune',
      'diabetes dietitian pune',
      'nutritionist near me pune',
    ],
    address: {
      line1: 'A305, Panchshil Soho',
      line2: 'near Panchshil Towers',
      area: 'Kharadi',
      cityLine: 'Pune 411014',
      full: 'A305, Panchshil Soho, near Panchshil Towers, Kharadi, Pune 411014',
      mapQuery: 'Panchshil Soho Kharadi Pune',
      geo: { lat: 18.5528, lng: 73.9411 },
    },
    since: 'Since 2013',
    neighbourhoods: [
      { name: 'Kharadi', desc: 'Home clinic. Face-to-face and online consults for EON Free Zone, WTC, and Zensar professionals.' },
      { name: 'Viman Nagar', desc: '10-minute drive. Great for Symbiosis students, Phoenix Marketcity shoppers and Airport-line residents.' },
      { name: 'Wagholi', desc: 'Fast-growing Kharadi extension. Home consult available in select apartments.' },
      { name: 'Chandan Nagar', desc: 'Neighbouring Kharadi. Personalised diet plans for young families and IT couples.' },
      { name: 'Kalyani Nagar', desc: 'Upmarket. PCOS, pre-wedding and menopause programs are our top requests here.' },
      { name: 'Magarpatta City', desc: 'One of our biggest client bases. Corporate wellness workshops on request.' },
      { name: 'Hadapsar', desc: 'Diabetes reversal and hypertension management are our most subscribed programs.' },
      { name: 'Koregaon Park', desc: 'Online consults preferred here. Meal plans tailored around cafe-heavy lifestyles.' },
    ],
    reviews: [
      { name: 'Sneha M.', area: 'Kharadi', text: 'Best dietitian in Kharadi hands down. I lost 7 kg in 4 months without giving up my daily poha.', rating: 5 },
      { name: 'Ankit R.', area: 'Viman Nagar', text: 'Drove down from Viman Nagar every fortnight and the plan finally fixed my acidity and belly fat.', rating: 5 },
      { name: 'Priya K.', area: 'Wagholi', text: 'Online consults from Wagholi worked perfectly. My PCOS cycles are regular after 3 months.', rating: 5 },
      { name: 'Rohan D.', area: 'Magarpatta', text: 'Prachi ma’am understands IT professional schedules like nobody else. Highly recommend.', rating: 5 },
    ],
    faq: [
      { q: 'Who is the best dietitian in Kharadi, Pune?', a: 'Nutritionist Prachi at NutrifyMe, A305 Panchshil Soho near Panchshil Towers Kharadi, is Kharadi’s highest-rated dietitian with over 10,000 transformations across Kharadi, Viman Nagar, Wagholi and Hadapsar.' },
      { q: 'How do I book a dietitian consultation in Kharadi?', a: 'Call +91 95454 05936 or click "Book Free Call" on this page. The first 15-minute discovery call is free and can be at the Kharadi clinic or online.' },
      { q: 'Do you offer diet consultations in Viman Nagar and Wagholi?', a: 'Yes. We serve clients across east Pune including Viman Nagar, Wagholi, Chandan Nagar, Kalyani Nagar, Magarpatta, Hadapsar and Koregaon Park. Most clients prefer online after the first visit.' },
      { q: 'What programs does the Kharadi clinic offer?', a: 'PCOS/PCOD, weight loss, weight gain, diabetes reversal, thyroid, pre and post pregnancy, pre-wedding, gut health, hypertension, sports and body-building nutrition. Every plan is personalised.' },
      { q: 'What is the address of the Kharadi clinic?', a: 'A305, Panchshil Soho, near Panchshil Towers, Kharadi, Pune 411014. It is a 3-minute drive from EON Free Zone and 8 minutes from Viman Nagar Chowk.' },
      { q: 'Is online consultation available?', a: 'Yes. Roughly 70% of our clients across Pune, other Indian cities, UAE, US and UK use online consultations. The results are identical to in-clinic visits.' },
      { q: 'What are the fees?', a: 'The 15-minute discovery call is free. Program fees start from ₹800 for a basic monthly plan and scale up based on the program depth. Full pricing is shared during the discovery call.' },
    ],
  },

  baner: {
    slug: 'dietitian-in-baner-pune',
    area: 'Baner',
    city: 'Pune',
    tagline: 'Serving Baner, Balewadi, Aundh & Pashan',
    heroTitle: 'Trusted Dietitian in Baner, Pune',
    heroSubtitle:
      'Personalised nutrition and diet plans for West Pune — weight loss, PCOS, diabetes, thyroid and pregnancy. Online consults available for Baner, Balewadi, Aundh, Pashan and Sus Road residents.',
    metaTitle: 'Best Dietitian in Baner, Pune — Nutritionist Prachi',
    metaDescription:
      'Top-rated dietitian in Baner, Pune. Personalised plans for weight loss, PCOS, diabetes and pregnancy — serving Baner, Balewadi, Aundh and Pashan. Free 15-min call.',
    keywords: [
      'dietitian in baner',
      'nutritionist baner pune',
      'dietitian balewadi',
      'dietitian aundh',
      'pcos dietitian baner',
      'weight loss dietitian baner',
      'best dietitian west pune',
    ],
    address: {
      line1: 'A305, Panchshil Soho',
      line2: 'near Panchshil Towers',
      area: 'Kharadi',
      cityLine: 'Pune 411014',
      full: 'A305, Panchshil Soho, near Panchshil Towers, Kharadi, Pune 411014 · Online for Baner',
      mapQuery: 'Baner Pune',
      geo: { lat: 18.5590, lng: 73.7868 },
    },
    since: 'Serving Baner since 2015',
    neighbourhoods: [
      { name: 'Baner', desc: 'Online consults with monthly clinic visits available. Popular with young professionals from Persistent, Symantec and BMC.' },
      { name: 'Balewadi', desc: 'High-Street residents and Balewadi Sports Complex regulars — sports nutrition on request.' },
      { name: 'Aundh', desc: 'Traditional and modern families. PCOS, thyroid and pregnancy nutrition are our top programs.' },
      { name: 'Pashan', desc: 'Neighbouring Sus Road and Baner. Diabetes reversal is our most requested program here.' },
      { name: 'Sus Road', desc: 'Newer societies, young couples, fertility and pre-pregnancy nutrition dominate here.' },
      { name: 'Bavdhan', desc: 'Family nutrition — kids, women, and elder nutrition all under one roof.' },
      { name: 'Wakad', desc: 'IT hub. Corporate wellness and desk-job nutrition programs are popular.' },
      { name: 'Hinjewadi', desc: 'Home consults for select societies, online for the rest.' },
    ],
    reviews: [
      { name: 'Deepa J.', area: 'Baner', text: 'Finally a dietitian who understands Punjabi food AND weight loss. Down 6 kg in 3 months, and no cravings.', rating: 5 },
      { name: 'Karthik S.', area: 'Balewadi', text: 'Prachi ma’am reversed my prediabetes. HbA1c from 6.2 to 5.4 in six months. Sustainable and easy to follow.', rating: 5 },
      { name: 'Meghna P.', area: 'Aundh', text: 'PCOS meal plan actually worked. Cycles regular, skin cleared, and I stopped hating my body.', rating: 5 },
      { name: 'Aditya G.', area: 'Pashan', text: 'Online consults from Pashan. Communication is quick, plans are Indian-friendly, results are real.', rating: 5 },
    ],
    faq: [
      { q: 'Who is the best dietitian in Baner, Pune?', a: 'Nutritionist Prachi at NutrifyMe is a top-rated dietitian serving Baner, Balewadi, Aundh and Pashan. 10,000+ transformations across India.' },
      { q: 'Do you have a clinic in Baner?', a: 'Our main clinic is at Panchshil Soho, Kharadi. Baner clients get online consults with the same personalisation and results — over 70% of our clients are online.' },
      { q: 'What are the fees for Baner consultations?', a: 'Free 15-minute discovery call. Paid programs start from ₹800 monthly and scale up based on program depth.' },
      { q: 'Can you help with PCOS in Baner?', a: 'Yes. PCOS/PCOD is one of our top three programs. Cycles typically regularise within 2 to 4 months of consistent nutrition.' },
      { q: 'How do online consultations work?', a: 'You get a WhatsApp check-in group, weekly meal plans in your dashboard, and scheduled video calls with your dietitian.' },
      { q: 'Do you offer sports nutrition for Balewadi Sports Complex members?', a: 'Yes. Performance nutrition, pre and post workout meals, and body-composition plans are all available.' },
    ],
  },

  hinjewadi: {
    slug: 'dietitian-in-hinjewadi-pune',
    area: 'Hinjewadi',
    city: 'Pune',
    tagline: 'Serving Hinjewadi, Wakad, Marunji & Tathawade',
    heroTitle: 'Dietitian for Hinjewadi IT Professionals',
    heroSubtitle:
      'Made for 9-to-9 IT life. Personalised diet plans, gut-friendly meals and stress-aware nutrition for Hinjewadi Phase 1, 2 and 3 residents — plus Wakad, Tathawade and Marunji.',
    metaTitle: 'Best Dietitian in Hinjewadi, Pune — Nutritionist Prachi',
    metaDescription:
      'Top-rated dietitian in Hinjewadi, Pune. Diet plans for IT professionals with irregular hours — weight loss, PCOS, gut health, diabetes. Free 15-min call.',
    keywords: [
      'dietitian in hinjewadi',
      'nutritionist hinjewadi',
      'dietitian wakad',
      'dietitian tathawade',
      'pcos dietitian hinjewadi',
      'weight loss it professionals',
      'best dietitian west pune',
    ],
    address: {
      line1: 'A305, Panchshil Soho',
      line2: 'near Panchshil Towers',
      area: 'Kharadi',
      cityLine: 'Pune 411014',
      full: 'A305, Panchshil Soho, near Panchshil Towers, Kharadi, Pune 411014 · Online for Hinjewadi',
      mapQuery: 'Hinjewadi Phase 1 Pune',
      geo: { lat: 18.5915, lng: 73.7381 },
    },
    since: 'Serving Hinjewadi since 2016',
    neighbourhoods: [
      { name: 'Hinjewadi Phase 1', desc: 'Infosys, TCS and Wipro professionals. Belly fat, sleep and gut are the top three complaints.' },
      { name: 'Hinjewadi Phase 2', desc: 'Cognizant, Accenture and Barclays folks. Weight loss and PCOS programs are most subscribed.' },
      { name: 'Hinjewadi Phase 3', desc: 'Newer flats and gated societies. Family and couple nutrition plans on request.' },
      { name: 'Wakad', desc: 'IT hub. Corporate wellness workshops and desk-job nutrition programs.' },
      { name: 'Marunji', desc: 'Growing residential belt. Diabetes and hypertension reversal is popular.' },
      { name: 'Tathawade', desc: 'Symbiosis area. Student nutrition and PCOS support.' },
      { name: 'Balewadi', desc: 'Neighbouring hub. Sports nutrition and body composition programs.' },
      { name: 'Baner', desc: 'Online consults available. Full program suite.' },
    ],
    reviews: [
      { name: 'Aakash V.', area: 'Hinjewadi Phase 1', text: 'Dropped 9 kg working 12-hour days. The plan literally fits between stand-ups. Life-changing.', rating: 5 },
      { name: 'Neha D.', area: 'Hinjewadi Phase 2', text: 'PCOS was making my life hell. Six months later my cycles are back and I sleep like a baby.', rating: 5 },
      { name: 'Sagar T.', area: 'Wakad', text: 'Reversed my prediabetes without going low-carb or extreme. Just smart Indian food and lifestyle nudges.', rating: 5 },
      { name: 'Isha M.', area: 'Tathawade', text: 'Student budget, real dietitian. Prachi ma’am tailored the plan to my hostel food. Genuinely helpful.', rating: 5 },
    ],
    faq: [
      { q: 'Who is the best dietitian near Hinjewadi?', a: 'Nutritionist Prachi at NutrifyMe. Fully online consults for Hinjewadi, with the same personalisation as in-clinic Kharadi visits.' },
      { q: 'Can a diet plan work for IT professionals with erratic hours?', a: 'Yes. Around 60% of our Hinjewadi clients are IT professionals. Plans are built around your calendar, not the other way round.' },
      { q: 'Do you have a Hinjewadi clinic?', a: 'Not yet. Consults for Hinjewadi are online. Our main clinic is at Panchshil Soho, Kharadi.' },
      { q: 'What is the fee?', a: 'Free 15-minute discovery call. Program fees start from ₹800 monthly.' },
      { q: 'Can you help with gut health and bloating?', a: 'Yes. Gut health is one of our specialty programs, especially for the sedentary, high-stress IT lifestyle.' },
      { q: 'How is online consult different from in-person?', a: 'Same dietitian, same plan quality, same weekly check-ins. Just video instead of driving.' },
    ],
  },

  mumbai: {
    slug: 'dietitian-in-mumbai',
    area: 'Mumbai',
    city: 'Maharashtra',
    tagline: 'Serving Bandra, Andheri, Powai, Thane & South Mumbai',
    heroTitle: 'Top Online Dietitian in Mumbai',
    heroSubtitle:
      'Personalised nutrition for Mumbai’s pace — weight loss, PCOS, diabetes and pregnancy. Fully online consults for Bandra, Andheri, Powai, Thane, South Mumbai and Navi Mumbai.',
    metaTitle: 'Best Online Dietitian in Mumbai — Nutritionist Prachi',
    metaDescription:
      'Top-rated online dietitian in Mumbai. Personalised Indian diet plans for weight loss, PCOS, diabetes and pregnancy — Bandra, Andheri, Powai, Thane. Book free 15-min call.',
    keywords: [
      'dietitian in mumbai',
      'nutritionist mumbai',
      'online dietitian mumbai',
      'dietitian bandra',
      'dietitian andheri',
      'dietitian powai',
      'dietitian thane',
      'pcos dietitian mumbai',
      'weight loss dietitian mumbai',
    ],
    address: {
      line1: 'A305, Panchshil Soho',
      line2: 'near Panchshil Towers',
      area: 'Kharadi',
      cityLine: 'Pune 411014',
      full: 'Online consults across Mumbai · Head office: Kharadi, Pune 411014',
      mapQuery: 'Mumbai India',
      geo: { lat: 19.0760, lng: 72.8777 },
    },
    since: 'Serving Mumbai since 2015',
    neighbourhoods: [
      { name: 'Bandra', desc: 'Coastal lifestyle, wedding season nutrition and PCOS are our top requests.' },
      { name: 'Andheri', desc: 'IT and media professionals. Weight loss and gut health programs dominate.' },
      { name: 'Powai', desc: 'Corporate corridor. Executive nutrition and sports performance in demand.' },
      { name: 'Thane', desc: 'Family programs — kids nutrition, women’s health and diabetes reversal.' },
      { name: 'South Mumbai', desc: 'Traditional families, hormone health, menopause and pregnancy plans.' },
      { name: 'Navi Mumbai', desc: 'Vashi, Nerul and Kharghar residents on online plans.' },
      { name: 'Ghatkopar', desc: 'Gujarati and Marathi families with cuisine-specific diet plans.' },
      { name: 'Malad', desc: 'Media professionals, PCOS and gut health specialists.' },
    ],
    reviews: [
      { name: 'Riya S.', area: 'Bandra', text: 'Best pre-wedding diet ever. I glowed and felt strong on my big day. Zero crash-dieting.', rating: 5 },
      { name: 'Vikram J.', area: 'Powai', text: 'Fixed my acidity and dropped 8 kg while working 60-hour weeks. Real dietitian, real results.', rating: 5 },
      { name: 'Sunita R.', area: 'Thane', text: 'Diabetes under control with food alone. My family eats the same meals — nobody feels deprived.', rating: 5 },
      { name: 'Farah M.', area: 'Andheri', text: 'The gut health program changed my skin and mood. Two months in and I feel like a new person.', rating: 5 },
    ],
    faq: [
      { q: 'Is there a dietitian in Mumbai I can consult online?', a: 'Yes. Nutritionist Prachi at NutrifyMe offers fully online consultations to Mumbai and Navi Mumbai clients, with the same personalisation as our Pune clinic.' },
      { q: 'Do you visit Mumbai in person?', a: 'Not currently. All Mumbai consultations are online. In-clinic visits are available at our Kharadi, Pune office.' },
      { q: 'How do online consults work?', a: 'You get a private WhatsApp group with your dietitian, weekly meal plans in your dashboard, and scheduled video check-ins.' },
      { q: 'What are the fees?', a: 'Free 15-minute discovery call. Paid programs start from ₹800 per month based on program depth.' },
      { q: 'Can you help with PCOS and thyroid in Mumbai?', a: 'Yes. Both are among our top three specialties. Most PCOS clients see cycle regularisation within 8 to 12 weeks.' },
      { q: 'Do you speak Marathi and Hindi?', a: 'Yes. Consultations are available in English, Hindi and Marathi.' },
    ],
  },
};

export const locationSlugs = Object.values(locations).map((l) => l.slug);
